import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import ERROR from './views/ERROR.vue'





/**个人中心 */
import PersonalMain from './views/PersonalMain.vue'
import ExamPaper from './views/personal/ExamPaper.vue'
import ExamScore from './views/personal/ExamScore.vue'
import ExamPaperPreview from './views/personal/ExamPaperPreview.vue'
import MyExam from './views/personal/MyExam.vue'

/*职业技能前台页面*/
const Index = resolve => require(['./views/Index.vue'], resolve)
const CourseCenter = resolve => require(['./views/container/courseCenter/CourseCenter'], resolve)
const SearchResult = resolve => require(['./views/container/courseCenter/SearchResult'], resolve)
const VueLogin = resolve => require(['./views/VueLogin.vue'], resolve)
const VueLoginSuper = resolve => require(['./views/VueLoginSuper.vue'], resolve)
const VuePersonalRegister = resolve => require(['./views/container/personalRegisterFogetPass/Register'], resolve)
const VuePersonalPassword = resolve => require(['./views/container/personalRegisterFogetPass/ForgetPassword'], resolve)
const VueOrgPassword = resolve => require(['./views/container/orgRegisterForgetPass/ForgetPassword'], resolve)
const VueLoginOrg = resolve => require(['./views/VueLoginOrg.vue'], resolve)
const VueOrgRegister = resolve => require(['./views/container/orgRegisterForgetPass/Register'], resolve)
const Agreement = resolve => require(['./views/container/personalRegisterFogetPass/AgreeMent'], resolve)
const AboutUs = resolve => require(['./views/container/courseCenter/AboutUs'], resolve)
const Policy = resolve => require(['./views/container/courseCenter/Policy'], resolve)
const Details = resolve => require(['./views/container/courseCenter/Details'], resolve)
const Base = resolve => require(['./views/container/courseCenter/Base'], resolve)
const Product = resolve => require(['./views/container/courseCenter/Product'], resolve)
const Feedback = resolve => require(['./views/container/courseCenter/Feedback'], resolve)
const Retrieval = resolve => require(['./views/container/courseCenter/Retrieval'], resolve)
const Result = resolve => require(['./views/container/courseCenter/Result'], resolve)
const WorkDetails = resolve => require(['./views/container/courseCenter/WorkDetails'], resolve)
const ResumeDelivery = resolve => require(['./views/container/courseCenter/ResumeDelivery'], resolve)
const HelpCenter = resolve => require(['./views/container/courseCenter/HelpCenter'], resolve)
const UsuallyProblem = resolve => require(['./views/container/courseCenter/UsuallyProblem'], resolve)
const CourseDetail = resolve => require(['./views/container/courseCenter/CourseDetail'], resolve)
const SureOrderMsg = resolve => require(['./views/container/courseCenter/SureOrderMsg'], resolve)
const PayOrder = resolve => require(['./views/container/courseCenter/PayOrder'], resolve)
const CountryPromote = resolve => require(['./views/container/courseCenter/CountryPromote'], resolve)


// 内蒙古项目
const NotificationAnnouncement = resolve => require(['./views/nmgPages/NotificationAnnouncement'], resolve)
const NmgLogin = resolve => require(['./views/nmgPages/NmgLogin'], resolve)

//绍兴项目
const ShaoxingShop = resolve => require(['./components/shaoxingComponents/ShaoxingShop'], resolve)
const ShaoXingOfflineTrainingClass = resolve => require(['./components/shaoxingComponents/ShaoXingOfflineTrainingClass'], resolve)
const ShaoXingOnlineRegistration = resolve => require(['./components/shaoxingComponents/ShaoXingOnlineRegistration'], resolve)
const ShaoXingSureOrderMsg = resolve => require(['./components/shaoxingComponents/ShaoXingSureOrderMsg'], resolve)
const ShaoXingPolicy = resolve => require(['./components/shaoxingComponents/ShaoXingPolicy'], resolve)
const ShaoXingPersonalClass = resolve => require(['./components/shaoxingComponents/ShaoXingPersonalClass'], resolve)
const ShaoXingPersonalCurriculum = resolve => require(['./components/shaoxingComponents/ShaoXingPersonalCurriculum'], resolve)
const ShaoXingPersonalExam = resolve => require(['./components/shaoxingComponents/ShaoXingPersonalExam'], resolve)
const ShaoXingPersonalSignUp = resolve => require(['./components/shaoxingComponents/ShaoXingPersonalSignUp'], resolve)
const ShaoXingOnlineTrainingCourseDetailsPage = resolve => require(['./components/shaoxingComponents/ShaoXingOnlineTrainingCourseDetailsPage'], resolve)
const ShaoXingIndexTop = resolve => require(['./components/shaoxingComponents/ShaoXingIndexTop'], resolve)
const ShaoXingAgainOnlineRegistration = resolve => require(['./components/shaoxingComponents/ShaoXingAgainOnlineRegistration'], resolve)





/*微信公众号*/
import MobileHome from './views/mobile/MobileHome'
import MobileCategory from './views/mobile/MobileCategory'
import MobileStudy from './views/mobile/MobileStudy'
import MobileClassRoom from './views/mobile/MobileClassRoom'
import MobileClass from './views/mobile/MobileClass'
import MobileClassDetail from './views/mobile/MobileClassDetail'
import MobileClassList from './views/mobile/MobileClassList'
import MobileLogin from './views/mobile/MobileLogin'
import MobileLoginYzm from './views/mobile/MobileLoginYzm'
import MobileRegister from './views/mobile/MobileRegister'
import MobileForgetPassword from './views/mobile/MobileForgetPassword'
import MobileForgetPasswordNext from './views/mobile/MobileForgetPasswordNext'
import MobilePersonal from './views/mobile/MobilePersonal'
import MobileCourseDetail from './views/mobile/MobileCourseDetail'
import MobileExam from './views/mobile/MobileExam'
import Login from './views/Login.vue';
import MobileMy from './views/mobile/MobileMy.vue';
import MobilePersonalMessage from './views/mobile/MobilePersonalMessage.vue';
import MobileAuthentication from './views/mobile/MobileAuthentication.vue';
import MobileSet from './views/mobile/MobileSet.vue';
import MobilePhoneNumber from './views/mobile/MobilePhoneNumber.vue';
import MobileNews from './views/mobile/MobileNews.vue';
import MobileService from './views/mobile/MobileService.vue'
import MobileSearchResult from './views/mobile/MobileSearchResult.vue'
import MobileNewsMore from './views/mobile/MobileNewsMore.vue'
import MobileCourseList from './views/mobile/MobileCourseList.vue'
import MobilePersonalNickname from './views/mobile/MobilePersonalNickname.vue'
import MobileFaceVerification from './views/mobile/MobileFaceVerification.vue'
import MobileAuthenticationFirst from './views/mobile/MobileAuthenticationFirst.vue'
import MobileAuthenticationSecond from './views/mobile/MobileAuthenticationSecond.vue'
import MobileCertificateUpload from './views/mobile/MobileCertificateUpload.vue'
import MobileExamAnalysis from './views/mobile/MobileExamAnalysis.vue'
import MobileAgreement from './views/mobile/MobileAgreement.vue'
import MobileBannerResult from './views/mobile/MobileBannerResult.vue'
import MobileExamList from './views/mobile/MobileExamList.vue'
import MobileBaiDuFace from './views/mobile/baiDuFace/index.vue'
import MobileVideoFace from './views/mobile/baiDuFace/MobileVideoFace.vue'
import MobileAnalysisWrongQuestions from './views/mobile/MobileAnalysisWrongQuestions.vue'




Vue.use(Router);

const router = new Router({


    routes: [
        { path: '/404', hidden: true, redirect: { path: '/404' } },
        { path: '/login', component: Login, name: '职业技能登录页' },
        { path: '/500', component: ERROR, name: '/500' }, /**注意这里的name不能修改 */
        {
            path: '/platAdmin',
            component: Home,
            name: '平台管理员',
            children: []
        },

        { path: '/work_index', component: Index, name: '首页', meta: { mainMenuIndex: 59, requireLogin: false, requireAuth: "", title: "首页", blankUrl: "/work_index" } },
        { path: '/work_course_center', component: CourseCenter, name: '选课中心', meta: { mainMenuIndex: 72, requireLogin: false, requireAuth: "", title: "选课中心", blankUrl: "/work_course_center" } },
        { path: '/search_result', component: SearchResult, name: '搜索结果页', meta: { mainMenuIndex: 2, requireLogin: false, requireAuth: "", title: "搜索结果页", blankUrl: "/search_result" } },
        { path: '/vueLogin', component: VueLogin, name: '个人登录', meta: { requireLogin: false, requireAuth: "", title: "个人登录页", blankUrl: "/vueLogin" } },
        { path: '/personalForgetPass', component: VuePersonalPassword, name: '个人忘记密码', meta: { requireLogin: false, requireAuth: "", title: "个人忘记密码页", blankUrl: "/personalForgetPass" } },
        { path: '/orgForgetPass', component: VueOrgPassword, name: '机构忘记密码', meta: { requireLogin: false, requireAuth: "", title: "机构忘记密码页", blankUrl: "/orgForgetPass" } },
        { path: '/personalRegister', component: VuePersonalRegister, name: '个人注册', meta: { requireLogin: false, requireAuth: "", title: "个人注册页", blankUrl: "/personalRegister" } },
        { path: '/vueLoginOrg', component: VueLoginOrg, name: '机构登录', meta: { requireLogin: false, requireAuth: "", title: "机构登录页", blankUrl: "/vueLoginOrg" } },
        { path: '/vueOrgRegister', component: VueOrgRegister, name: '机构注册', meta: { requireLogin: false, requireAuth: "", title: "机构注册页", blankUrl: "/vueLoginOrg" } },
        { path: '/agreement', component: Agreement, name: '协议', meta: { requireLogin: false, requireAuth: "", title: "协议", blankUrl: "/agreement" } },
        { path: '/aboutUs', component: AboutUs, name: '关于我们', meta: { mainMenuIndex: 3, requireLogin: false, requireAuth: "", title: "关于我们", blankUrl: "/aboutUs" } },
        { path: '/policy', component: Policy, name: '政策资讯', meta: { mainMenuIndex: 80, requireLogin: false, requireAuth: "", title: "政策资讯", blankUrl: "/policy" } },
        { path: '/details', component: Details, name: 'details', meta: { mainMenuIndex: 6, requireLogin: false, requireAuth: "", title: "详情", blankUrl: "/details" } },
        { path: '/base', component: Base, name: '线下培训基地', meta: { mainMenuIndex: 4, requireLogin: false, requireAuth: "", title: "线下培训基地", blankUrl: "/base" } },
        { path: '/product', component: Product, name: '产品服务', meta: { mainMenuIndex: 5, requireLogin: false, requireAuth: "", title: "产品服务", blankUrl: "/product" } },
        { path: '/feedback', component: Feedback, name: '意见反馈', meta: { mainMenuIndex: 1, requireLogin: false, requireAuth: "", title: "意见反馈", blankUrl: "/feedback" } },
        { path: '/retrieval', component: Retrieval, name: '职业检索', meta: { mainMenuIndex: 7, requireLogin: false, requireAuth: "", title: "职业检索", blankUrl: "/retrieval" } },
        { path: '/result', component: Result, name: '检索结果', meta: { mainMenuIndex: 7, requireLogin: false, requireAuth: "", title: "检索结果", blankUrl: "/Result" } },
        { path: '/work_details', component: WorkDetails, name: '职位详情', meta: { mainMenuIndex: 2, requireLogin: false, requireAuth: "", title: "职位详情", blankUrl: "/workDetails" } },
        { path: '/resume_delivery', component: ResumeDelivery, name: '简历投递', meta: { mainMenuIndex: 2, requireLogin: false, requireAuth: "", title: "简历投递", blankUrl: "/resumeDelivery" } },
        { path: '/helpCenter', component: HelpCenter, name: '帮助中心', meta: { mainMenuIndex: 83, requireLogin: false, requireAuth: "", title: "帮助中心", blankUrl: "/helpCenter" } },
        { path: '/usuallyProblem', component: UsuallyProblem, name: '常见问题', meta: { mainMenuIndex: 8, requireLogin: false, requireAuth: "", title: "常见问题", blankUrl: "/usuallyProblem" } },
        { path: '/courseDetail', component: CourseDetail, name: '课程详情', meta: { mainMenuIndex: 2, requireLogin: false, requireAuth: "", title: "课程详情", blankUrl: "/courseDetail" } },
        { path: '/sureOrderMsg', component: SureOrderMsg, name: '确认订单信息', meta: { mainMenuIndex: 2, requireLogin: false, requireAuth: "", title: "确认订单信息", blankUrl: "/sureOrderMsg" } },
        { path: '/payOrder', component: PayOrder, name: '支付订单', meta: { mainMenuIndex: 2, requireLogin: false, requireAuth: "", title: "支付订单", blankUrl: "/payOrder" } },
        { path: '/countryPromote', component: CountryPromote, name: '乡村振兴', meta: { mainMenuIndex: 9, requireLogin: false, requireAuth: "", title: "乡村振兴", blankUrl: "/countryPromote" } },
        { path: '/vueLoginSuper', component: VueLoginSuper, name: '主管登录', meta: { requireLogin: false, requireAuth: "", title: "主管登录", blankUrl: "/vueLoginSuper" } },

        //  内蒙古项目
        { path: '/notificationAnnouncement', component: NotificationAnnouncement, name: '通知公告', meta: { requireLogin: false, requireAuth: "", title: "通知公告", blankUrl: "/notificationAnnouncement" } },
        { path: '/nmgLogin', component: NmgLogin, name: '内蒙古登录', meta: { requireLogin: false, requireAuth: "", title: "内蒙古登录", blankUrl: "/nmgLogin" } },

        //  绍兴项目
        { path: '/shaoxingshop', component: ShaoxingShop, name: '绍兴购物车', meta: { requireLogin: false, requireAuth: "", title: "绍兴购物车", blankUrl: "/shaoxingshop" } },
        { path: '/shaoxingofflinetrainingclass',component: ShaoXingOfflineTrainingClass, name: '绍兴线上报名', meta: { requireLogin: false, requireAuth: "", title: "绍兴线上报名", blankUrl: "/shaoxingshop" } },
        { path: '/shaoxingonlineregistration', component: ShaoXingOnlineRegistration, name: '线上报名', meta: { requireLogin: false, requireAuth: "", title: "线上报名", blankUrl: "/shaoxingonlineregistration" } },
        { path: '/shaoxingsureordermsg', component: ShaoXingSureOrderMsg, name: '绍兴确认订单', meta: { requireLogin: false, requireAuth: "", title: "绍兴确认订单", blankUrl: "/shaoxingpersonal" } },
        { path: '/shaoxingpolicy', component: ShaoXingPolicy, name: '绍兴政策通知', meta: { requireLogin: false, requireAuth: "", title: "绍兴政策通知", blankUrl: "/shaoxingpolicy" } },
        { path: '/shaoxingpersonalclass', component: ShaoXingPersonalClass, name: '绍兴我的班级', meta: { requireLogin: false, requireAuth: "", title: "绍兴个人中心", blankUrl: "/shaoxingpersonalclass" } },
        { path: '/shaoxingpersonalcurriculum', component: ShaoXingPersonalCurriculum, name: '绍兴我的课程', meta: { requireLogin: false, requireAuth: "", title: "绍兴我的课程", blankUrl: "/shaoxingpersonalcurriculum" } },
        { path: '/shaoxingpersonalexam', component: ShaoXingPersonalExam, name: '绍兴我的考试', meta: { requireLogin: false, requireAuth: "", title: "绍兴我的考试", blankUrl: "/shaoxingpersonalexam" } },
        { path: '/shaoxingpersonalsignup', component: ShaoXingPersonalSignUp, name: '绍兴我的报名', meta: { requireLogin: false, requireAuth: "", title: "绍兴我的报名", blankUrl: "/shaoxingpersonalsignup" } },
        { path: '/shaoxingonlinepage', component: ShaoXingOnlineTrainingCourseDetailsPage, name: '绍兴线下培训班', meta: { requireLogin: false, requireAuth: "", title: "绍兴线下培训班", blankUrl: "/shaoxingonlinepage" } },
        { path: '/shaoxingindextop', component: ShaoXingIndexTop, name: '绍兴个人中心头部', meta: { requireLogin: false, requireAuth: "", title: "绍兴个人中心头部", blankUrl: "/shaoxingindextop" } },
        { path: '/shaoxingagainonlineregistration', component: ShaoXingAgainOnlineRegistration, name: '绍兴重新报名', meta: { requireLogin: false, requireAuth: "", title: "绍兴重新报名", blankUrl: "/shaoxingonlineregistration" } },





        /** 个人中心 */
        {
            path: '/personal',
            component: PersonalMain,
            name: '个人中心',
            redirect: '/personal/personalSet',
            children: [
                { path: '/personal/myexam', component: MyExam, name: '我的考试', meta: { requireLogin: true, ifStudent: true } },
            ]
        },
        { path: '/exampaper', component: ExamPaper, name: '考试详情', meta: { requireLogin: true, ifStudent: true } },
        { path: '/ExamPaperPreview', component: ExamPaperPreview, name: '考试预览' },
        { path: '/examscore', component: ExamScore, name: '考试结果', meta: { requireLogin: true, ifStudent: true } },
        { path: '/mobileHome', component: MobileHome, name: "H5推荐页", },
        { path: '/mobileCategory', component: MobileCategory, name: "一级分类页", },
        { path: '/mobileLogin', component: MobileLogin, name: "登录", },
        { path: '/mobileLoginYzm', component: MobileLoginYzm, name: "验证码登录", },
        { path: '/mobileRegister', component: MobileRegister, name: "注册", },
        { path: '/mobileForgetPassword', component: MobileForgetPassword, name: "忘记密码", },
        { path: '/mobileForgetPasswordNext', component: MobileForgetPasswordNext, name: "修改密码", },
        { path: '/mobileStudy', component: MobileStudy, name: "我的学习", meta: { requireLogin: true, ifStudent: true } },
        { path: '/mobileClassRoom', component: MobileClassRoom, name: "自选课程", },
        { path: '/mobileClass', component: MobileClass, name: "我的课程", },
        { path: '/mobileClassDetail', component: MobileClassDetail, name: "培训班详情", },
        { path: '/mobileClassList', component: MobileClassList, name: "我的培训班", },
        { path: '/mobilePersonal', component: MobilePersonal, name: "个人设置", meta: { requireLogin: true, ifStudent: true } },
        { path: '/mobileCourseDetail', component: MobileCourseDetail, name: "课程详情", },
        { path: '/mobileExam', component: MobileExam, name: "我的考试", },
        { path: '/mobileMy', component: MobileMy, name: "我的", meta: { requireLogin: true, ifStudent: true } },
        { path: '/mobilePersonalMessage', component: MobilePersonalMessage, name: "个人信息", },
        { path: '/mobileAuthentication', component: MobileAuthentication, name: "实名认证", },
        { path: '/mobileSet', component: MobileSet, name: "设置", },
        { path: '/mobilePhoneNumber', component: MobilePhoneNumber, name: "修改号码", },
        { path: '/mobileNews', component: MobileNews, name: "我的消息", },
        { path: '/mobileService', component: MobileService, name: "客服服务", },
        { path: '/mobileSearchResult', component: MobileSearchResult, name: "搜索结果", },
        { path: '/mobileNewsMore', component: MobileNewsMore, name: "消息列表", },
        { path: '/mobileCourseList', component: MobileCourseList, name: "课程列表", },
        { path: '/mobilePersonalNickname', component: MobilePersonalNickname, name: "修改昵称", },
        { path: '/mobileFaceVerification', component: MobileFaceVerification, name: "人脸验证", },
        { path: '/mobileAuthenticationFirst', component: MobileAuthenticationFirst, name: "普通实名", },
        { path: '/mobileAuthenticationSecond', component: MobileAuthenticationSecond, name: "人脸实名", },
        { path: '/mobileCertificateUpload', component: MobileCertificateUpload, name: "证件上传", },
        { path: '/mobileExamAnalysis', component: MobileExamAnalysis, name: "考试解析", },
        { path: '/mobileAnalysisWrongQuestions', component: MobileAnalysisWrongQuestions, name: "错题解析", },
        { path: '/mobileAgreement', component: MobileAgreement, name: "注册协议", },
        { path: '/mobileBannerResult', component: MobileBannerResult, name: "分类栏结果", },
        { path: '/mobileExamList', component: MobileExamList, name: "考试列表", },
        { path: '/mobileBaiDuFace', component: MobileBaiDuFace, name: "百度人脸", },
        { path: '/mobileVideoFace', component: MobileVideoFace, name:'视频人脸', }
    ]
});
import { Toast } from 'vant';
Vue.use(Toast);

// 全局路由守卫
router.beforeEach((to, from, next) => {
    // let token = localStorage.getItem('realName')
    // console.log(to);
    if (to.name === `意见反馈` && !(sessionStorage.getItem('realName'))) {
        router.push({ path: '/vueLogin' });
    } else {
        next()
    }
})
export default router;


// WEBPACK FOOTER //
// ./src/routes.js